export function getRoute(menu) {
  if (menu.get('urlAuxiliar')) {
    return menu.get('route') + menu.get('urlAuxiliar');
  }

  return menu.get('route');
}
